import React from "react";
import Image from "react-bootstrap/Image";

export const UserFavoritesRestaurantTablebody = ({
  restaurantImage,
  restaurantName,
  restaurantDesc,
  restaurantId,
  restaurantLocation,
  userImage,
  userName,
  userDate,
  userTime,
  comments,
  status,
}) => {
  return (
    <tr className="enUserFavoritesTableBody">
      <td style={{ width: "16.66%" }}>
        <div className="d-flex flex-column">
          {/* <div className="restaurant_image_box">
            <Image
              src={restaurantImage}
              alt="Restaurant pic"
              title="Restaurant Pic"
              fluid
            />
          </div> */}
          <p className="f14-700 mt-2 mb-0">{restaurantName}</p>
          <p className="f10-500 mt-2 mb-0">{restaurantId}</p>
        </div>
      </td>
      {/* <td style={{ width: "16.66%" }}>
        <div className="f14-500"></div>
      </td> */}
      <td style={{ width: "16.66%" }}>
        <div className="col-12 p-0 d-flex align-items-center">
          <div className="restaurant_image_box_user">
            {/* <Image
              src={userImage}
              alt="Profile pic"
              title="Profile Pic"
              fluid
              className="restaurant_image_box_user mr-0"
            /> */}
          </div>
          <div className="f12-500">{userName}</div>
        </div>
      </td>
      <td style={{ width: "16.66%" }}>
        <div className="f14-500">{userDate}</div>
        <div className="f14-500">{userTime}</div>
      </td>
      <td style={{ width: "22.66%" }}>
        <div className={`${comments === "Favourite was added" ? 'greendot' : "reddot"} f14-500 flexcenter`}> {comments}</div>
      </td>
      {/* <td style={{ width: "10.66%" }}>
        <div className="f14-500">{status}</div>
      </td> */}
    </tr>
  );
};
